import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import Vuelidate from 'vuelidate';
import Clipboard from 'v-clipboard';
import VueContentPlaceholders from 'vue-content-placeholders'
import VueClipboard from 'vue-clipboard2'
import VueChatScroll from 'vue-chat-scroll'
import VueCountdown from '@chenfengyuan/vue-countdown';
import VueBarcodeScanner from 'vue-barcode-scanner'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#25aae1',
    secondary: '#0D47A1',
    success: '#388E3C',
    info: '#ffaa2c',
    error: '#B71C1C',
    warning:'#FBC02D'
  }
})

Vue.use(Clipboard);
Vue.use(Vuelidate);
Vue.use(VueContentPlaceholders)
Vue.use(VueClipboard)
Vue.use(VueChatScroll)
Vue.component(VueCountdown.name, VueCountdown);

let BCRoptions = {
  sound: true, // default is false
  soundSrc: 'sound.wav', // default is blank
  sensitivity: 300, // default is 100
  requiredAttr: true, // default is false
  controlSequenceKeys: ['NumLock', 'Clear'], // default is null
  callbackAfterTimeout: true // default is false
}

Vue.use(VueBarcodeScanner, BCRoptions)



Vue.filter('truncate', function (text, length, suffix) {
  return text.substring(0, length) + suffix;
});

Vue.filter('formatDate', function (value) {
  if (value) {
    let d = new Date(value).toLocaleString('en-GB')
    return `${d}`
  }
});